import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SendToMobileIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M17,17h2v4c0,1.1-0.9,2-2,2H7c-1.1,0-2-0.9-2-2V3c0-1.1,0.9-1.99,2-1.99L17,1c1.1,0,2,0.9,2,2v4h-2V6H7v12h10V17z M22,12 l-4-4v3h-5v2h5v3L22,12z" />
  </SvgIcon>
);
SendToMobileIcon.displayName = 'SendToMobileIcon';
SendToMobileIcon.muiName = 'SvgIcon';

export default SendToMobileIcon;
